import { render, staticRenderFns } from "./BatchDiagnoseDetail.vue?vue&type=template&id=05b1dc9b"
import script from "./BatchDiagnoseDetail.vue?vue&type=script&lang=js"
export * from "./BatchDiagnoseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports